<template>
  <div>
    <!-- Header -->
    <div class="header bg-gradient-info py-7 py-lg-8 pt-lg-9" style="padding-bottom:100px!important;">
      <div class="container">
        <div class="header-body text-center mb-7">
          <div class="row justify-content-center">
            <div class="col-xl-5 col-lg-6 col-md-8 px-5">
            <!--  <h1 class="text-white">{{brand}}</h1> -->
              <p class="text-lead text-white">Welcome & login</p>
            </div>
          </div>
        </div>
      </div>
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg x="0" y="0" viewBox="0 0 2560 100" preserveAspectRatio="none" version="1.1"
             xmlns="http://www.w3.org/2000/svg">
          <polygon class="fill-default" points="2560 0 2560 100 0 100"></polygon>
        </svg>
      </div>
    </div>
    <!-- Page content -->
    <div class="container mt--8 pb-5">
      <div class="row justify-content-center">
        <div class="col-lg-5 col-md-7">
          <div class="card bg-secondary border-0 mb-0">
            <div class="card-body px-lg-5 py-lg-5">
              <div class="text-center text-muted mb-4">
                <small>Sign in with credentials</small>
              </div>
              <validation-observer v-slot="{handleSubmit}" ref="formValidator">
                <form role="form" @submit.prevent="login()">
                  <base-input alternative
                              class="mb-3"
                              name="Email"
                              :rules="{required: true, email: true}"
                              prepend-icon="ni ni-email-83"
                              placeholder="Email"
                              v-model="model.email">
                  </base-input>

                  <base-input alternative
                              class="mb-3"
                              name="Password"
                              :rules="{required: true, min: 6}"
                              prepend-icon="ni ni-lock-circle-open"
                              type="password"
                              placeholder="Password"
                              v-model="model.password">
                  </base-input>

                  <base-checkbox v-model="model.rememberMe">Remember me</base-checkbox>
                  <div class="text-center">
                    <base-button type="primary" native-type="submit" class="my-4">Sign in</base-button>
                  </div>
                </form>
              </validation-observer>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-6">
              <router-link to="/forgot-password" class="text-light"><small>Forgot password?</small></router-link>
            </div>
            <div class="col-6 text-right">
              <router-link to="/register" class="text-light"><small>Create new account</small></router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
 import {UserService} from '@/services/user.service'
 import swal from 'sweetalert2';
 import 'sweetalert2/dist/sweetalert2.css';
  
 
  export default {
    data() {
      return {
      	brand:'',
        model: {
          email: '',
          password: '',
          rememberMe: false
        }
      };
    },
    mounted(){
  		this.brand = this.$cs_app_long_name;
    },
    methods: {
      onSubmit() {
        // this will be called only after form is valid. You can do api call here to login
      },
      login(e) {
      	const vm = this;
        // handle login here
       
        //this.submitted = true;
         swal.showLoading();
        
        UserService.login(this.model.email, this.model.password)
                .then(function(response){
                
					if(response.data.success == 0){
						swal.fire({
							title: 'Oops',
							text: response.data.error,
							buttonsStyling: false,
							confirmButtonClass: 'btn btn-warning',
							icon: 'warning'
						  })
							
					}
					else{
						swal.close();
						if(response.data.user_info.view_type == "new"){
      	 					vm.$router.push( '/onboarding-redirect')
      	 				}
      	 				else if(response.data.user_info.view_type == "multi"){
      	 					vm.$router.push( '/ec-selector')
      	 				}
      	 				else if(response.data.user_info.view_type == "single"){
      	 					vm.$router.push( '/ec_dashboard')
      	 				}
      	 			   
      	 			}
      	 	});
      }
    }
  };
</script>
